import React, { useState, useEffect } from 'react';

import styles from './styles.module.scss';

import { useContext } from 'react';

import 'moment/locale/fa';

import Cookies from 'js-cookie';
import Api from '../../api';
import Loader from '../Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import SHARED from '../../constants';
import AppIcons from '../../icons';

import FileTypeComponent from '../FileTypeComponent';
import FileTypesContainer from '../FileTypesContainer';
import { AdminContext } from '../../context/AdminContext';
import SingleMessage from '../SingleMessage';
import MessageTypes from '../ActiveChatInfo/MessageTypes';

const FileSection = ({
  content,
  uuidUser = '',
  extraScrollDivStyle,
  extraScrollDivStyleInside,
  favorite=false,
  messages,
  setMessages,
}) => {
  const [serverError, setServerError] = useState('');

  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [count, setCount] = useState(0);

  const [activePlayer, setActivePlayer] = useState();
  const {
    activeMessage,
    setActiveMessage,
    activeUser,
    setActiveAudio,
    activeMenuFile,
    themeMode,
    userChannelId, privateUsers,setShowFirstMessage,setUserChannelId,    previousChannelId,
    setPreviousChannelId, setActiveUser,    sharedUserClicked,
    setSharedUserClicked,     setSharedUser, setTrigger
  } = useContext(AdminContext);

  // const {userChannelId, privateUsers,setShowFirstMessage,setUserChannelId,    previousChannelId,
  //   setPreviousChannelId, setActiveUser,    sharedUserClicked,
  //   setSharedUserClicked,     setSharedUser, setTrigger}= useContext(AdminContext)
const switchToShare = (user) => {

    console.log('userrrrrrr', user, userChannelId);

    if (userChannelId != user?.uuid) {

      setActiveUser();
      setSharedUserClicked(user?.name);
      startChatFunction(user);
      setSharedUser(user);
    }
  };
  const startChatFunction = (y) => {
    setTrigger("")
    console.log('sssss', privateUsers, y.uuid);
    let index = privateUsers.findIndex(
      (x) => x?.users?.[0]?.channelUser?.uuid == y.uuid
    );
    if (index == -1) {

      setShowFirstMessage(true);
      setPreviousChannelId(userChannelId);

      setUserChannelId(y?.uuid);

      const newuser = {
        ...y,
        block: 0,
        users: [
          {
            unSeen: 0,
            block: 0,
            channelUser: {

              channelName: y?.name,
              uuid: y?.uuid,
            },
          },
        ],
      };

    } else {
      setUserChannelId(y?.uuid);
    }
  };


  const [activeMenu, setActiveMenu] = useState(
    favorite ? 0 : activeMenuFile ? activeMenuFile?.subMenu :   1
  );
  const [menus,setMenus]= useState(favorite==false ? content?.folderPart?.menu?.slice(1) : content?.folderPart?.menu)

  useEffect(() => {
    if (activeMenuFile?.subMenu) {
      if (favorite){
        setActiveMenu(0)
      }else{
        setActiveMenu(activeMenuFile?.subMenu);
      }
    }

  }, [activeMenuFile]);
  console.log("activeMenu", activeMenu)

  useEffect(() => {
    setLoading(true);

    if (favorite==false){
    findList(0, 15);
    }else{
    let listType=  'message' 
    findListFav(0, 15, false,listType );
    }
  }, []);

  useEffect(() => {
    setLoading(true);

    if (favorite==false){
    findList(0, 15);
    }else{
    let listType= activeMenu == 0 ? 'message' : 'file'
    findListFav(0, 15, false,listType );
    }
  }, [activeMenu]);

  const findList = (start = 0, limit = 15, infinite = false) => {
    const activeType = content?.folderPart?.menu?.filter(
      (x) => x.id == activeMenu
    )?.[0]?.fileType;
    if (!infinite) {
      setLoading(true);
    }
    Api.mediaList({
      params: {
        fileType: activeType,
        start: start,
        limit: limit,
        uuidUser: uuidUser,
      },
    })
      .then((res) => {
        callbackFunction(res, infinite);
      })
      .catch((err) => {
        setLoading(false);
      });

  };
  const findListFav=(start = 0, limit = 15, infinite = false,listType='message')=>{
    const activeType = content?.folderPart?.menu?.filter(
      (x) => x.id == activeMenu
    )?.[0]?.fileType;
    if (!infinite) {
      setLoading(true);
    }

    Api.favList(activeUser?.id,{params:{ start: start,
      limit: limit, listType:listType,fileType: listType != "message" ? activeType : '',
  }})
        .then((res)=>{
          callbackFunction(res, infinite);
        })
        .catch((err)=>{
            setLoading(false);
        })
}
  const getMorePosts = () => {
    if (favorite==false){
    findList(files?.length, 10, true);
    }else{
    let listType= activeMenu == 0 ? 'message' : 'file'
    findListFav(files?.length, 10, true, listType);

    }
  };

  const callbackFunction = (res, infinite = false) => {
    let newarray=[]
    if (infinite) {
      if (favorite==false){
        newarray = [...files.concat(res?.data?.response)];
      }else{
      newarray = [...files.concat(res?.data?.response?.map((d) => ({ ...d.chat})))];

      }
      setFiles(newarray);
    } else {
      if (favorite==false){
         newarray=res?.data?.response
      }else{
        newarray=res?.data?.response?.map((d) => ({ ...d.chat}))
      }
      setFiles(
          newarray
        );
    }
    setLoading(false);
    setCount(res?.data?.response_details?.count);
  };
  useEffect(() => {
    setHasMore(files.length < count);

    if (files.length == 0) {
      setHasMore(false);
    }
  }, [files, count]);
  const activePlayerFunction = (playerId) => {
    // alert('hi');
    console.log('playerId', playerId, activePlayer);
    if (activePlayer) {
      activePlayer.pause(); // Pause previous active player
    }

    setActivePlayer(playerId);
    // activePlayer = playerId;
    // playerId.play();
  };
  useEffect(() => {
    console.log('activePlayer', activePlayer);
    if (activePlayer) {
      activePlayer.play();
    }
  }, [activePlayer]);

  useEffect(() => {
    // setActiveMessage('');
    // setActiveAudio();
  }, [activeUser, activeMenu]);

  const favFunction=(x)=>{
    console.log("ccccc", x)
    Api.favMessage(x.id, {roomId:x?.roomId ? x?.roomId : x?.room?.id})
    .then((res)=>{
      let array=[...messages]
      if (array[array.findIndex(m=>m?.id==x?.id)]?.chatPin?.length != 0){
        array[array.findIndex(m=>m?.id==x?.id)].chatPin=[]
      }else{
        array[array.findIndex(m=>m?.id==x?.id)].chatPin=[{}]
      }
      setMessages(array)
      let fileArray=[...files]
      fileArray=fileArray?.filter(f=>f.id != x.id)
      setFiles(fileArray)
      setCount(count -1 )
    })
    .catch((err)=>{})
  }
  console.log('files', files, count, hasMore, content?.folderPart?.menu);
  console.log("activeMenu", activeMenu)
  return (
    <div
      className={` flex flex-col justify-start items-center w-full h-full relative ${styles.container} ${extraScrollDivStyle}`}
    >
      <div className={`${styles.menu} `}>

        {menus?.map((item, index) => (
          <p
            onClick={() => {
              setActiveMenu(item?.id);
            }}
            key={index}
            className={` text-center
              ${
                activeMenu == item?.id
                  ? `${styles.activeMenu} mainTextColor mainBorderBottomColor`
                  : styles.unActiveMenu
              } `}
          >
            {item?.name}
          </p>
        ))}

        {/* <iframe
          src={`https://3d.lotuspion.com/share`}
          style={{ width: '100%' }}
        /> */}
      </div>
      <div
        className={`flex flex-row justify-start items-start  box-border pb-6 ${
          styles.flexStyle
        } ${themeMode == 'dark' && styles.dark} ${extraScrollDivStyleInside}`}
        id="scrollableDivFile"
        style={{ minHeight: '100%', height: '100%', overflowY: 'scroll' }}
      >
        <div
          className={`flex flex-col justify-start items-start box-border ${styles.sideWidth} w-[100%] h-[100%] px-6`}
        >
          {serverError !== '' && (
            <div className={styles.serverError}>
              <AppImage
                src="/imgs/login/warning.svg"
                alt="warning"
                width={20}
                height={20}
                containerclassName="flex flex-row justify-center items-center"
              />
              <span>{serverError}</span>
            </div>
          )}
        </div>
        {loading ? (
          <Loader width={`w-full h-400px `} />
        ) : (
          <InfiniteScroll
            style={{ overflowY: 'hidden', width: '100%' }}
            dataLength={files?.length}
            next={() => getMorePosts()}
            hasMore={hasMore}
            scrollThreshold={'50px'}
            loader={<Loader width={'w-full'} height={'h-[100px]'} />}
            scrollableTarget="scrollableDivFile"
          >
            {files?.length != 0 ? (
              <>
                {files?.map((item, index) => (
                  <>
                  { activeMenu != 0  ? 
                  
                  <>
                  {favorite ? 
                  <SingleMessage key={index}  chatBody={false} item={item} content={content} favFunction={favFunction}>  
                  <FileTypesContainer
                    item={item}
                    chatBody={ item?.file?.fileExtension?.type != 'music' ? true :false}
                    activePlayer={setActivePlayer}
                    activePlayerFunction={activePlayerFunction}
                    activeMessage={activeMessage}
                    setActiveMessage={setActiveMessage}
                    messages={files}
                    key={index}
                    favFunction={favFunction}

                  />
                  </SingleMessage>
                  :
                  <FileTypesContainer
                  item={item}
                  chatBody={false}
                  activePlayer={setActivePlayer}
                  activePlayerFunction={activePlayerFunction}
                  activeMessage={activeMessage}
                  setActiveMessage={setActiveMessage}
                  messages={files}
                  key={index}
                  />
                  }
                  </>
                  :

                  <SingleMessage key={index}  chatBody={false} item={item} content={content} favFunction={favFunction}>            <MessageTypes
                  message={item}
                  switchToShare={switchToShare}
                  content={content}
                /></SingleMessage>}
                  </>
                ))}
              </>
            ) : (
              <p className={styles.noInfoFound}>{content?.noInfoFound}</p>
            )}
          </InfiniteScroll>
        )}
      </div>
    </div>
  );
};

export default FileSection;
